import React from 'react';
import { IconButton, type IconButtonProps } from '../icon-button/icon-button';

export type TagButtonProps = IconButtonProps;

export const TagButton = React.forwardRef<
  React.ElementRef<'button'>,
  TagButtonProps
>((props, ref) => {
  return <IconButton {...props} mode={100} variant="ghost" ref={ref} />;
});

TagButton.displayName = 'Tag.Button';
